module.exports = __webpack_public_path__ + "assets/img/nanjing.146f3806.png";